export { default } from './CoverFooter';
